const NOTIFICATION_QUERY_KEYS = {
  all: ['notifications'] as const,
  list: (accountId: string) => [...NOTIFICATION_QUERY_KEYS.all, accountId] as const,
  unreadCount: (accountId: string) =>
    [...NOTIFICATION_QUERY_KEYS.all, 'unread-count', accountId] as const,
};

export { NOTIFICATION_QUERY_KEYS };
